<!-- 首页 -->
<template>
	<div>
		<!-- 统计 -->
		<div class="box" style="padding-bottom: 10px">
			<home-data-statistics></home-data-statistics>
		</div>

		<!-- 待办 -->
		<div class="box" style="margin-top: 20px">
			<div class="flex-c-s">
				<div class="flex">
					<div :class="['menu-item', { title: index == menuActive }]" v-for="(item, index) in menu"
						:key="index" @click="switchMenu(index)">
						{{ item.title }}
						<div class="item-icon" v-show="menuActive == index"></div>
						<div class="status-count" v-if="item.count > 0">{{ item.count }}</div>
					</div>
				</div>
				<div class="flex">
					<div class="refresh-btn" style="margin-right: 10px" v-if="isShowAddBtn" @click="openAdd">
						<i class="el-icon-plus"></i> 新建工单
					</div>
					<div class="refresh-btn" @click="handleRefresh">
						<i class="el-icon-refresh"></i> 刷新
					</div>
				</div>
			</div>

			<div class="work-container" infinite-scroll-immediate="false" v-infinite-scroll="moreWorkOrder"
				v-for="(item, index) in menu" :key="index" v-show="menu[menuActive].id === item.id"
				v-loading="item.loading">
				<work-order-list :list="item.list" :btns="btns" @refresh="refreshDistributed"></work-order-list>
				<div class="no-data" v-if="item.list.length == 0">暂无工单</div>
			</div>
		</div>
		<home-fault-trend></home-fault-trend>
		<add-order @refresh="refreshDistributed" ref="addOrder"></add-order>
	</div>
</template>

<script>
	import HomeDataStatistics from '@/components/Home/HomeDataStatistics.vue'
	import WorkOrderList from '@/components/WorkOrder/WorkOrderList.vue'
	import HomeFaultTrend from '@/components/Home/HomeFaultTrend.vue'
	import AddOrder from '@/components/WorkOrder/AddOrder.vue'
	export default {
		components: {
			HomeDataStatistics,
			WorkOrderList,
			HomeFaultTrend,
			AddOrder
		},
		data() {
			return {
				menu: [{
						id: '1',
						title: '待分配',
						list: [],
						page: 1,
						more: true,
						loading: false,
						count: 0
					},
					{
						id: '2',
						title: '待接单',
						list: [],
						page: 1,
						more: true,
						loading: false,
						count: 0
					},
					{
						id: '3',
						title: '待验收',
						list: [],
						page: 1,
						more: true,
						loading: false,
						count: 0
					}
				],
				menuActive: 0,
				// 首页默认拥有处理工单权限
				btns: {
					'del-order': true,
					'handle-order': true
				}
			}
		},
		computed: {
			userType() {
				return this.$store.state.user.userType
			},
			// 服务是否已延期
			isShowAddBtn(){
				let showAddBtn = sessionStorage.getItem('endDay');
				if(showAddBtn && Number(showAddBtn)<0){
					return false;
				}else{
					return true;
				}
			}
		},
		watch: {},
		mounted() {
			this.getDistributedOrder(0)
			this.getOrderStatusCount();
		},
		methods: {
			// 切换菜单
			switchMenu(index) {
				this.menuActive = index
				Object.assign(
					this.menu[this.menuActive],
					this.$options.data().menu[this.menuActive]
				)
				this.refreshDistributed(this.menuActive);
			},
			
			// 获取待分配工单列表
			getDistributedOrder(active) {
				const type =
					this.userType == '0' ? 'needDistributeAdmin' : 'needDistribute'
				const item = this.menu[active || this.menuActive]
				item.loading = true

				this.$api.home[type]({
						limit: 2,
						page: item.page
					})
					.then(({
						data
					}) => {
						item.loading = false
						if (data.code == 200) {
							item.list.push(...data.data)
							// 是否还有更多
							const length = item.list.length
							if (data.total <= length) {
								item.more = false
							}
							this.$forceUpdate()
						}
					})
					.catch(() => {
						item.more = false
						item.loading = false
					})
			},

			// 模块刷新
			refreshDistributed(status = 0) {
				this.$set(this.menu, status, {
					...this.menu[status],
					list: [],
					page: 1,
					more: true
				})
				this.menuActive = status;
				if (status == 1) {
					this.getNeedReceiveList()
				} else if (status == 2) {
					this.getProcessedOrder()
				} else {
					this.getDistributedOrder()
				}
				this.getOrderStatusCount();
			},

			// 获取待接单列表
			getNeedReceiveList(active) {
				const type = this.userType == '0' ? 'needReceiveAdmin' : 'needReceive'
				const item = this.menu[active || this.menuActive]
				item.loading = true

				this.$api.home[type]({
						limit: 2,
						page: item.page
					})
					.then(({
						data
					}) => {
						item.loading = false
						if (data.code == 200) {
							item.list.push(...data.data)
							// 是否还有更多
							const length = item.list.length
							if (data.total <= length) {
								item.more = false
							}
							this.$forceUpdate()
						}
					})
					.catch(() => {
						item.more = false
						item.loading = false
					})
			},

			// 获取待验收工单列表
			getProcessedOrder(active) {
				const type = this.userType == '0' ? 'dataEvaluateAdmin' : 'dataEvaluate'
				const item = this.menu[active || this.menuActive]
				item.loading = true

				this.$api.home[type]({
						limit: 2,
						page: item.page
					})
					.then(({
						data
					}) => {
						item.loading = false
						if (data.code == 200) {
							item.list.push(...data.data)
							// 是否还有更多
							const length = item.list.length
							if (data.total <= length) {
								item.more = false
							}
							this.$forceUpdate()
						}
					})
					.catch(() => {
						item.more = false
						item.loading = false
					})
			},

			// 加载更多工单
			moreWorkOrder() {
				const item = this.menu[this.menuActive]
				// 没有更多则打断
				if (!item.more) {
					return
				}
				item.page++
				if (this.menuActive === 0) {
					this.getDistributedOrder()
				} else if (this.menuActive === 1) {
					this.getNeedReceiveList()
				} else {
					this.getProcessedOrder()
				}
			},

			// 手动刷新
			handleRefresh() {
				this.refreshDistributed(this.menuActive);
			},

			// 获取工单列表对应状态数量
			async getOrderStatusCount() {
				const params = {
					countType: 0
				}
				const {
					data
				} = await this.$api.order.sheetListCount(params)
				if (data.code === 200) {
					for (let item of this.menu) {
						if (item.title == "待分配") {
							item.count = data.data.distribute;
						} else if (item.title == "待接单") {
							item.count = data.data.receive;
						} else if (item.title == "待验收") {
							item.count = data.data.replay;
						}
					}
				}
			},

			openAdd() {
				this.$refs.addOrder.open()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		padding: 30px 25px;
		background: #ffffff;
		border-radius: 14px;
	}

	.title {
		font-size: 16px;
		font-weight: bold;
		color: #333333 !important;
	}

	.refresh-btn {
		color: #409eff;
		cursor: pointer;
	}

	.menu-item {
		margin-right: 80px;
		color: rgba(51, 51, 51, 0.4);
		margin-bottom: 33px;
		position: relative;
		cursor: pointer;

		:last-child {
			margin-right: 0;
		}

		.item-icon {
			position: absolute;
			bottom: -12px;
			left: 50%;
			transform: translateX(-50%);
			width: 23px;
			height: 3px;
			background: #4799ff;
		}

		.status-count {
			position: absolute;
			top: -15px;
			right: -15px;
			width: 20px;
			height: 20px;
			background: red;
			border-radius: 50%;
			color: #fff;
			font-size: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.work-container {
		max-height: 500px;
		overflow: auto;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 10px;
			background: rgba(0, 0, 0, 0.2);
		}

		&::-webkit-scrollbar-track {
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}
	}

	.no-data {
		text-align: center;
		color: #999;
	}
</style>
